import * as React from 'react'
import { pagination } from './pagination'

export const infoItem = (title: string, icon: string, height: number, width: number) => {
  return (
    <li className="info__item">
      <span>{title}</span>
      <svg className="info__icon" aria-hidden="true" height={height} width={width}>
        <use xlinkHref={`#icon--${icon}`} />
      </svg>
    </li>
  )
}

export const vacancy = (title: string, intro?: string) => {
  return (
    <li className="vacancy">
      <article className="vacancy__inner">
        <a href="/" className="vacancy__link">
          <header className="vacancy__header">
            <h3 className="vacancy__title title--xs">{title}</h3>
            {intro && <p className="vacancy__intro">{intro}</p>}
            <span className="vacancy__icon" />
          </header>
          <ul className="info__list">
            {infoItem('Bridgwater UK', 'pin', 24, 16)}
            {infoItem('Fulltime', 'clock', 24, 22)}
            {infoItem('Supply chain', 'department', 22, 22)}
          </ul>
        </a>
      </article>
    </li>
  )
}

export const tag = (copy: string) => {
  return (
    <li className="tags__item">
      <button className="tag">
        <span className="tag__copy">{copy}</span>
        <svg className="tag__remove" aria-hidden="true" width="12px" height="12px"><use xlinkHref="#icon--cross" /></svg>
      </button>
    </li>
  )
}

export const vacanciesOverview = () => {
  return ( 
    <section className="vacancies">
      <div className='vacancies__inner container container--m grid--gutter'>
        <header className="vacancies__header">
          <h2 className="vacancies__title title--s">Number of pages</h2>
        </header>
        <div className="tags">
          <ul className="tags__list">
            {tag('Lorem')}
            {tag('United kingdom')}
            {tag('Italy')}
            {tag('Full time')}
          </ul>
        </div>
        <ul className="vacancies__list">
          {vacancy('Vehicula Elit', 'Morbi leo risus, porta ac consectetur ac, vestibulum at eros. Donec ullamcorper nulla non metus auctor fringilla.')}
          {vacancy('Morbi leo risus, porta ac consectetur ac', 'Vestibulum at eros. Donec ullamcorper nulla non metus auctor fringilla.')}
          {vacancy('Vehicula Elit', 'Morbi leo risus, porta ac consectetur ac, vestibulum at eros. Donec ullamcorper nulla non metus auctor fringilla.')}
          {vacancy('Morbi leo risus, porta ac consectetur ac', 'Vestibulum at eros. Donec ullamcorper nulla non metus auctor fringilla.')}
        </ul>
        {pagination()}
      </div>
    </section>
  )
}
